define('app/views/templates/helpers/labelFinder',['Handlebars'], function ( Handlebars ){
    function labelFinder(obj, key) {
        var categoryMap = {
            Spa: {
                ServiceNameLabel: 'spaNameLabel',
                LocationLabel : 'spaLocationLabel',
                recipientLabel : 'spaRecipientLabel',
                serviceDateLabel: 'spaServiceDateLabel',
                EquipmentLabel: 'spaEquipmentLabel'
            },
            Hotel: {
                ServiceNameLabel: 'hotelNameLabel',
                LocationLabel : 'roomTypeLabel',
                recipientLabel : 'packageTypeLabel',
                serviceDateLabel: 'arrivalDateLabel',
            },
            Dining: {
                ServiceNameLabel: 'diningNameLabel',
                LocationLabel : 'diningLocationLabel',
                recipientLabel : 'diningRecipientLabel',
                serviceDateLabel: 'diningDateLabel',
                AreaLabel : 'diningAreaLabel',
            },
            Golf: {
                ServiceNameLabel: 'golfNameLabel',
                LocationLabel : 'golfLocationLabel',
                recipientLabel : 'golfRecipientLabel',
                serviceDateLabel: 'golfDateLabel',
            },
            Club: {
                ServiceNameLabel: 'clubNameLabel',
                recipientLabel : 'clubRecipientLabel',
                LocationLabel : 'clubLocationLabel',
                serviceDateLabel: 'clubDateLabel',
               
            },
            PMSPayment:{
                ServiceNameLabel: 'pmsPaymentNameLabel',
                LocationLabel : 'pmsPaymentLocationLabel',
                recipientLabel : 'pmsPaymentRecipientLabel',
                serviceDateLabel: 'pmsPaymentServiceDateLabel',
            },
            SPAPayment:{
                ServiceNameLabel: 'spaPaymentNameLabel',
                LocationLabel : 'spaPaymentLocationLabel',
                recipientLabel : 'spaPaymentRecipientLabel',
  
            },
            Retail: {
                ServiceNameLabel: 'retailNameLabel',
                LocationLabel : 'retailLocationLabel',
                recipientLabel : 'retailRecipientLabel',
                serviceDateLabel: 'retailServiceDateLabel',
                EquipmentLabel: 'retailEquipmentLabel'
            },
            SpaWait: {
                ServiceNameLabel: 'spaWaitNameLabel',
                LocationLabel : 'spaWaitLocationLabel',
                recipientLabel : 'spaWaitRecipientLabel',
                serviceDateLabel: 'spaWaitServiceDateLabel',
                EquipmentLabel: 'spaWaitEquipmentLabel'
            },
            Ski: {
                ServiceNameLabel: 'skiNameLabel',
                serviceDateLabel: 'skiDateLabel',
                LocationLabel: 'skiLocationLabel',
                recipientLabel : 'skiRecipientLabel',
            }
        }
        return app.localization.bookingSummaryV2[categoryMap[obj.Category][key]];
    }

    Handlebars.registerHelper( 'labelFinder', labelFinder );
    return labelFinder;
});
